import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import Navbar from "../components/header/Navbar";
import Album from "../components/dashboard/Album";
import Footer from "../components/Footer";
import ProfileSidebar from "../components/dashboard/ProfileSidebar";
import { uploadAvatar, getUserById, updateUserById } from "../services/userService";
import type { SysUser } from "../types/user";
import bg_sidebar from "../assets/photo_koala/pexels-tkirkgoz-6045786.jpg"
import bg_main from "../assets/photo_koala/pexels-nxbid0-21579905.jpg"


const Dashboard: React.FC = () => {
  const { user, updateUser } = useUser();
  const navigate = useNavigate();

  const [uploading, setUploading] = useState(false);
  const [profile, setProfile] = useState({
    avatarUrl: "",
    name: "",
    bio: "",
    country: "",
  });

  useEffect(() => {
    const fetchProfile = async () => {
      if (!user) return;
      try {
        const freshUser: SysUser = await getUserById(user.userId);
        setProfile({
          avatarUrl: freshUser.avatar || "",
          name: freshUser.name || "",
          bio: freshUser.bio || "",
          country: freshUser.country || "",
        });
      } catch (error) {
        console.error("Failed to load user profile:", error);
      }
    };

    fetchProfile();
  }, [user]);

  if (!user) {
    return (
      <div className="text-center mt-20 text-gray-500">
        You are not logged in.
      </div>
    );
  }

  const handleAvatarUpload = async (file: File): Promise<string> => {
    setUploading(true);
    try {
      const uploadedUrl = await uploadAvatar(file, user.userId);
      const updatedUser = { ...user, avatar: uploadedUrl };
      updateUser(updatedUser);
      setProfile((prev) => ({ ...prev, avatarUrl: uploadedUrl }));
      return uploadedUrl;
    } catch (err) {
      alert("Upload failed");
      console.error("Error uploading avatar:", err);
      throw err;
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />

      <div className="flex flex-1 flex-col md:flex-row">
        {/* Sidebar - 1/4 width on desktop, full width on mobile */}
        <div className="relative w-full md:w-1/4 min-h-screen shadow-md bg-primaryAlt overflow-y-auto transform transition-all">
          <div id="sidebar-bg"
            style={{
              backgroundImage: `url(${bg_sidebar})`,
              backgroundSize: "cover",
              filter: "brightness(.5)",
              height: "100%",
              position: "absolute",
              top: 0,
              width: "100%"
            }}>
          </div>
          <ProfileSidebar
            avatarUrl={profile.avatarUrl}
            name={profile.name}
            bio={profile.bio}
            country={profile.country}
            email={user.email}
            lastLoginDate={user.lastLoginDate}
            onUpload={handleAvatarUpload}
            loading={uploading}
          />
        </div>

        {/* Main content - 3/4 on desktop, full width on mobile */}
        <main className="relative w-full md:w-3/4">
          <div id="main-bg"
            className="bg-center bg-backgroundAlt text-white bg-blend-multiply overflow-hidden absolute w-full h-full top-0"
            style={{
              backgroundImage: `url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAPUlEQVQIW2NkgALtmsTNV1vm+zLCBHQqUjez3HpszKhTnbL5D+NfBparz4yvrN8pBVZhEOT17MK6bVIgNgBUvBO1R5/vswAAAABJRU5ErkJggg=="),url(${bg_main})`,
              backgroundRepeat: 'repeat, no-repeat',
              backgroundSize: 'auto, cover',
              filter: "brightness(.5)",
              backgroundPosition: 'center',
              backgroundAttachment: 'scroll',
            }}
          >
          </div>
          <Album />
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default Dashboard;
